import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import PropertiesTable from './ProperiesTable';

const Properties = () => {
    return (
        <PropertiesTable />
    );
}

export default Properties